export { Blockquote } from '@mantine/core'
